<script setup lang="ts">
import RowCustomerContent from './RowCustomerContent.vue'

import type { PropsRowCustomer } from './RowCustomerContent.vue'

withDefaults(defineProps<PropsRowCustomer>(), {
  countryFlag: null,
  email: null,
  hasOptin: null,
  hasOptinEmail: null,
  loyaltyCardNumber: null,
  name: null,
  phone: null
})
</script>

<template>
  <div>
    <router-link
      v-if="id"
      class="text-primary hover:text-primary/80"
      :to="{
        name: 'CustomerDetail',
        params: {
          customerId: id
        }
      }"
    >
      <RowCustomerContent
        :id="id"
        :country-flag="countryFlag"
        :email="email"
        :has-optin="hasOptin"
        :loyalty-card-number="loyaltyCardNumber"
        :name="name"
        :phone="phone"
      />
    </router-link>
    <div v-else class="text-muted-foreground">
      <RowCustomerContent
        :id="id"
        :country-flag="countryFlag"
        :email="email"
        :has-optin="hasOptin"
        :loyalty-card-number="loyaltyCardNumber"
        :name="name"
        :phone="phone"
      />
    </div>
  </div>
</template>
